import { render, staticRenderFns } from "./workarea.vue?vue&type=template&id=bb35a9dc&scoped=true&"
import script from "./workarea.vue?vue&type=script&lang=js&"
export * from "./workarea.vue?vue&type=script&lang=js&"
import style0 from "./workarea.vue?vue&type=style&index=0&id=bb35a9dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb35a9dc",
  null
  
)

export default component.exports